export default __webpack_public_path__ + "static/media/Person.f125fba6.svg";